import Vue from "vue";
import isObject from "../utils/isObject";

export default {
  error(message = "", errors, options = {}) {
    if (isObject(errors) && Object.keys(errors).length > 0) {
      const makeErrors = errors => Object.keys(errors)
        .map(key => errors[key].map(detail => `<li>${key}: ${detail}</li>`).join(""));

      this.notify({
        type: "error",
        title: message,
        text: `<ul>${makeErrors(errors).join("")}</ul>`,
        ...options
      });
    } else {
      this.notify({
        type: "error",
        title: message,
        ...options
      });
    }
  },
  success(message, options) {
    this.notify({
      type: "success",
      title: message,
      ...options
    });
  },
  notify() {
    Vue.notify(...arguments);
  }

};
